export default __webpack_public_path__ + "static/media/dai-icon.196bd5b1.png";